import HowTo from "../../components/sub/HowTo";
import AboutImg from "../../images/Heading.png";
import Testimonials from "../../components/sub/Testimonials";
import ContentBelow from "../../components/ContentBelow";
import classes from "../../App.module.css";
import Button from "../../components/Button";
import background from "../../images/home_background.png";
import home_01 from "../../images/Home-01.png";
import home_02 from "../../images/Home-02.png";

import Head from "../../components/Head";
import FQA from "../FQA";

function HomePage() {
  return (
    <>
      <Head imageUrl={background} backgroundAttachment="fixed">
        <div className={`text-start text-sm-left ${classes.heading_div}`}>
          <h2 className={classes.h2}>
            WeBridge: Your solution to advance payments on settled RAF Claims
          </h2>

          <p>
            - Settled RAF Claim Bridging Finance <br />
            - Attorney Fee Bridging Finance <br />
            - Property Bridging Finance <br />
            - Business Growth Finance <br />- Advocate Accounts Factoring
          </p>

          <Button name="Apply" link="/Applynow">
            Apply
          </Button>
        </div>
      </Head>
      <ContentBelow>
        <div className="container-fluid text-center m-4 p-2 w-50 mx-auto">
          <img src={home_01} className="img-fluid" width={700} alt="Home 01" />

          <p className={classes.did_you_know}>
            Did you know that settled RAF Claim payouts can take longer than 180
            days to pay out?
          </p>
          <p>
            <em>
              No need to wait any longer for your RAF claim payout if your claim
              is settled. Apply today and access the funds you need!
            </em>
          </p>

          <Button name="Apply now" link="/applynow"></Button>
        </div>
      </ContentBelow>
      <div className=" container-fluid text-center m-4 p-2 w-75 mx-auto">
        <HowTo />
      </div>
      {/* <div className={classes.howto_OuterDiv}>
        <HowTo />
      </div> */}
      <div className={classes.aboutUs}>
        <div className="container">
          <div className="row mt-5 mb-5">
            <div className="col-sm-5 col-md-5">
              {/* color h:#347cb6 */}

              <h2>8 Years of Trust and Personalized Service</h2>
              <p>
                For over 8 years, we've been committed to supporting our
                clients' financial well-being with personalized service and
                genuine care.
              </p>
              <p>
                Unlike impersonal call centres or AI bots, at WeBridge, you'll
                always speak to a real person who understands your needs and is
                dedicated to helping you every step of the way.
              </p>
              <p>
                Your financial urgency is our priority, and we’re here to make
                the process as smooth and supportive as possible.
              </p>
              <Button name="More about us" link="/AboutUs"></Button>
            </div>
            <div className="col-sm-5 col-md-7">
              <img
                src={home_02}
                width={900}
                className=" img-fluid"
                style={{ borderRadius: 20 }}
              ></img>
            </div>
          </div>
        </div>
      </div>
      <div className="container my-5">
        <div
          className="mx-auto col-12 col-md-10 col-lg-8 text-center mb-2"
          style={{ color: "#113358" }}
        >
          <h2>Client Testimonials</h2>
          <h5>What People Say About Us</h5>
        </div>
        <Testimonials />
      </div>
      <div className=" container my-5" style={{ color: "#113358" }}>
        <h2 className={`text-center mb-4`}>Frequently Asked Questions</h2>
        <div className="mx-auto col-12 col-md-10 col-lg-8">
          <FQA />
        </div>
      </div>
    </>
  );
}

export default HomePage;
